import { formatDisplayDate } from "../utils/dateFormat";
import DateInputField from "./DateInputField";

function ReportesPanel({
  rango,
  reporte,
  cierreDiario,
  cierresDiarios = [],
  movimientos,
  canDeleteManual = false,
  canManageClose = false,
  onDeleteMovimientoManual,
  onChangeRango,
  onConsultar,
  onCloseDiario,
  onExportCsv,
  onVerComprobante,
}) {
  const movimientosFiltrados = (movimientos || []).filter((m) => {
    const dentroDesde = !rango.fechaInicio || m.fecha >= rango.fechaInicio;
    const dentroHasta = !rango.fechaFin || m.fecha <= rango.fechaFin;
    return dentroDesde && dentroHasta;
  });
  return (
    <section className="panel">
      <div className="section-title">
        <h2>Reporte global</h2>
        <span>{formatDisplayDate(rango.fechaInicio)} a {formatDisplayDate(rango.fechaFin)}</span>
      </div>

      <div className="report-filter-grid">
        <label>
          <span className="visually-hidden">Desde</span>
          <DateInputField name="fechaInicio" value={rango.fechaInicio} onChange={onChangeRango} ariaLabel="Desde" />
        </label>
        <label>
          <span className="visually-hidden">Hasta</span>
          <DateInputField name="fechaFin" value={rango.fechaFin} onChange={onChangeRango} ariaLabel="Hasta" />
        </label>
        <button type="button" className="secondary-button edit-action" onClick={onConsultar}>Consultar</button>
        <button type="button" className="secondary-button" onClick={onExportCsv}>Exportar CSV</button>
      </div>

      <div className="summary-grid panel-grid report-kpis">
        <article className="stat-card panel">
          <span>Total reservas</span>
          <strong>{reporte.total_reservas}</strong>
        </article>
        <article className="stat-card panel">
          <span>Pagadas</span>
          <strong className="status-ok">{reporte.reservas_pagadas}</strong>
        </article>
        <article className="stat-card panel">
          <span>Pendientes</span>
          <strong className="status-warn">{reporte.reservas_pendientes}</strong>
        </article>
        <article className="stat-card panel">
          <span>Canceladas</span>
          <strong className="status-danger">{reporte.reservas_canceladas}</strong>
        </article>
        <article className="stat-card panel">
          <span>Ingresos</span>
          <strong className="status-ok">${reporte.ingresos.toFixed(2)}</strong>
        </article>
        <article className="stat-card panel">
          <span>Egresos</span>
          <strong className="status-danger">${reporte.egresos.toFixed(2)}</strong>
        </article>
        <article className="stat-card panel">
          <span>Saldo</span>
          <strong className={reporte.saldo >= 0 ? "status-ok" : "status-danger"}>${reporte.saldo.toFixed(2)}</strong>
        </article>
      </div>

      {cierreDiario ? (
        <section className="closure-card">
          <div className="section-title">
            <h3 style={{ margin: 0 }}>Cierre diario</h3>
            <span>{formatDisplayDate(cierreDiario.fecha)}</span>
          </div>
          <div className="summary-grid closure-summary-grid">
            <article className="stat-card panel">
              <span>Saldo apertura</span>
              <strong>${Number(cierreDiario.saldo_apertura || 0).toFixed(2)}</strong>
            </article>
            <article className="stat-card panel">
              <span>Ingresos del día</span>
              <strong className="status-ok">${Number(cierreDiario.ingresos || 0).toFixed(2)}</strong>
            </article>
            <article className="stat-card panel">
              <span>Egresos del día</span>
              <strong className="status-danger">${Number(cierreDiario.egresos || 0).toFixed(2)}</strong>
            </article>
            <article className="stat-card panel">
              <span>Saldo cierre</span>
              <strong className={(cierreDiario.saldo_cierre || 0) >= 0 ? "status-ok" : "status-danger"}>
                ${Number(cierreDiario.saldo_cierre || 0).toFixed(2)}
              </strong>
            </article>
          </div>
          <p className={cierreDiario.cerrado ? "status-ok" : "status-warn"} style={{ marginTop: 12 }}>
            {cierreDiario.cerrado
              ? `Día cerrado por ${cierreDiario.cerrado_por_username} el ${cierreDiario.cerrado_en}.`
              : "Día todavía abierto. Puedes cerrarlo formalmente para dejar saldo guardado y bloquear cambios."}
          </p>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 12 }}>
            {canManageClose && cierreDiario.puede_cerrar ? (
              <button type="button" className="secondary-button edit-action" onClick={onCloseDiario}>
                Cerrar día
              </button>
            ) : null}
            {canManageClose && onVerComprobante ? (
              <button type="button" className="secondary-button" onClick={() => onVerComprobante(cierreDiario.fecha)}>
                Ver comprobante
              </button>
            ) : null}
          </div>
        </section>
      ) : null}

      {cierresDiarios.length > 0 ? (
        <section style={{ marginTop: 20 }}>
          <div className="section-title">
            <h3 style={{ margin: 0 }}>Cierres registrados</h3>
            <span>{cierresDiarios.length} elementos</span>
          </div>
          <div className="report-table-wrap">
            <table className="report-table">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Apertura</th>
                  <th>Ingresos</th>
                  <th>Egresos</th>
                  <th>Cierre</th>
                  <th>Usuario</th>
                  {onVerComprobante ? <th></th> : null}
                </tr>
              </thead>
              <tbody>
                {cierresDiarios.map((cierre) => (
                  <tr key={cierre.fecha}>
                    <td>{formatDisplayDate(cierre.fecha)}</td>
                    <td>${Number(cierre.saldo_apertura).toFixed(2)}</td>
                    <td className="status-ok">${Number(cierre.ingresos).toFixed(2)}</td>
                    <td className="status-danger">${Number(cierre.egresos).toFixed(2)}</td>
                    <td>${Number(cierre.saldo_cierre).toFixed(2)}</td>
                    <td>{cierre.cerrado_por_username}</td>
                    {onVerComprobante ? (
                      <td>
                        <button
                          type="button"
                          className="secondary-button"
                          style={{ padding: "4px 10px", fontSize: 12 }}
                          onClick={() => onVerComprobante(cierre.fecha)}
                        >
                          Comprobante
                        </button>
                      </td>
                    ) : null}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      ) : null}

      <div className="report-table-wrap">
        <table className="report-table">
          <thead>
            <tr>
              <th>Cancha</th>
              <th>Reservas</th>
              <th>Pagadas</th>
              <th>Pendientes</th>
              <th>Canceladas</th>
              <th>Facturado</th>
            </tr>
          </thead>
          <tbody>
            {reporte.desglose_por_cancha.map((item) => (
              <tr key={item.cancha}>
                <td>{item.cancha}</td>
                <td>{item.reservas}</td>
                <td className="status-ok">{item.pagadas}</td>
                <td className="status-warn">{item.pendientes}</td>
                <td className="status-danger">{item.canceladas}</td>
                <td>${item.facturado.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="section-title" style={{ marginTop: 24 }}>
        <h3 style={{ margin: 0 }}>Movimientos de caja</h3>
        <span>{movimientosFiltrados.length} elementos</span>
      </div>
      <div className="list-stack" style={{ marginTop: 12 }}>
        {movimientosFiltrados.length === 0 ? <p>No hay movimientos en este período.</p> : null}
        {movimientosFiltrados.map((m) => (
          <div className="list-item" key={m.id}>
            <div className="movimiento-item-row">
              <div className="movimiento-item-main">
                <strong className={m.tipo === "ingreso" ? "status-ok" : "status-danger"}>
                  {m.tipo.toUpperCase()}
                </strong>
                <span>{m.concepto}</span>
                <span>{formatDisplayDate(m.fecha)}</span>
                <span className={m.tipo === "ingreso" ? "status-ok" : "status-danger"}>
                  ${Number(m.monto).toFixed(2)}
                </span>
              </div>
              {m.reserva_id == null && canDeleteManual ? (
                <button
                  type="button"
                  className="secondary-button danger"
                  onClick={() => onDeleteMovimientoManual(m)}
                >
                  Eliminar manual
                </button>
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ReportesPanel;
